// Loading Reducer
const initialState = {
  requests: 0,
  isLoading: false,
};

const loadingReducer = (state = initialState, action: any) => {
  if (action.type.endsWith("/pending")) {
    return {
      requests: state.requests + 1,
      isLoading: true,
    };
  }

  if (action.type.endsWith("/fulfilled") || action.type.endsWith("/rejected")) {
    const requests = Math.max(0, state.requests - 1);
    return {
      requests,
      isLoading: requests > 0,
    };
  }

  return state;
};

export default loadingReducer;
